import { useQuery } from '@tanstack/react-query';
import { getCreditsBalance } from '../services/referrals.service';

export const CREDITS_BALANCE_QUERY_KEY = ['credits', 'balance'] as const;

/**
 * The user's heru-cash balance (whole pesos). One cache for every surface that
 * shows it, so a change that moves the balance (a plan change downgrade, a
 * purchase) refreshes all of them by invalidating this key. `fresh` reads it again
 * on mount: the purchase success screen must not show the balance from before the burn.
 */
export const useCreditsBalance = ({
	enabled = true,
	fresh = false,
}: { enabled?: boolean; fresh?: boolean } = {}) =>
	useQuery({
		queryKey: CREDITS_BALANCE_QUERY_KEY,
		queryFn: getCreditsBalance,
		enabled,
		retry: false,
		staleTime: 60 * 1000,
		refetchOnMount: fresh ? 'always' : true,
	});
